// frontend/src/components/Auth/VerifyEmail.jsx
// Email 驗證組件

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Button, Paper } from '@mui/material';
import { CheckCircle as SuccessIcon, Error as ErrorIcon } from '@mui/icons-material';
import authService from '../../services/authService';

const VerifyEmail = ({ token }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('無效的驗證連結');
        setLoading(false);
        return;
      }

      try {
        const response = await authService.verifyEmail(token);
        if (response.success) {
          setSuccess(true);
        } else {
          setError(response.message || '驗證失敗');
        }
      } catch (err) {
        const errorMessage = err.response?.data?.message || '驗證失敗，請稍後再試';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  const handleGoToHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 8,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 3 }}>
          正在驗證您的 Email...
        </Typography>
      </Box>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 2,
        textAlign: 'center',
        bgcolor: 'transparent',
      }}
    >
      {success ? (
        <Box>
          <SuccessIcon
            sx={{
              fontSize: 80,
              color: 'success.main',
              mb: 2,
            }}
          />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            Email 驗證成功！
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            您的電子郵件已成功驗證，現在可以使用完整功能了。
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button variant="contained" onClick={handleGoToHome}>
              返回首頁
            </Button>
            <Button variant="outlined" onClick={handleGoToLogin}>
              前往登入
            </Button>
          </Box>
        </Box>
      ) : (
        <Box>
          <ErrorIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2,
            }}
          />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            驗證失敗
          </Typography>
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            {error}
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            驗證連結可能已過期或已被使用。如果您需要重新驗證，請登入後在個人資料頁面重新發送驗證信。
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button variant="contained" onClick={handleGoToLogin}>
              前往登入
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default VerifyEmail;
